/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the context for the currently loaded country.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to create a context.
 */
import * as React from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import * as Dtos from '../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

interface IScreeningDialogContext {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    patientStudyNumber: string | null;
    setPatientStudyNumber: (patientStudyNumber: string | null) => void;
    screeningOutcome: Dtos.LookupScreeningOutcomeType | null,
    setScreeningOutcome: (screeningOutcome: Dtos.LookupScreeningOutcomeType | null) => void;
    institutionCode: string | null | undefined;
}




/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const ScreeningDialogContext = React.createContext<IScreeningDialogContext>({
    dialogOpen: false,
    setDialogOpen: (_open) => undefined,
    patientStudyNumber: null,
    setPatientStudyNumber: (_patientStudyNumber) => undefined,
    screeningOutcome: null,
    setScreeningOutcome: (_screeningOutcome) => undefined,
    institutionCode: null
});

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default ScreeningDialogContext;